import React from 'react';
import SpinnerComponents from '@shared/spinner/spinner.components';

const { Container, RingsContainer, Ring } = SpinnerComponents;

const SpinnerContent: React.FunctionComponent = () => {
  return (
    <Container>
      <RingsContainer>
        <Ring />
        <Ring />
        <Ring />
        <Ring />
      </RingsContainer>
    </Container>
  );
};

export default SpinnerContent;
